/**
 * Food Safety temperature glance colours.
 * Pass = in range / at-or-above min target (green).
 * Fail = out of range / below min (amber).
 * Corrective notes stay quiet olive — never alert-red.
 */

export const FOOD_SAFETY_TEMP_TONE = {
  PASS: 'pass',
  FAIL: 'fail',
  UNKNOWN: 'unknown',
}

/** Readable on white cards (not neon lettuce — text must stay legible). */
export const FOOD_SAFETY_TEMP_TONE_COLOUR = {
  [FOOD_SAFETY_TEMP_TONE.PASS]: '#5a9e0b',
  [FOOD_SAFETY_TEMP_TONE.FAIL]: '#c47a12',
  [FOOD_SAFETY_TEMP_TONE.UNKNOWN]: '#000000',
}

/**
 * @param {boolean|null|undefined} outOfRange
 * @returns {'pass'|'fail'|'unknown'}
 */
export function foodSafetyTempToneFromOutOfRange(outOfRange) {
  if (outOfRange === true) return FOOD_SAFETY_TEMP_TONE.FAIL
  if (outOfRange === false) return FOOD_SAFETY_TEMP_TONE.PASS
  return FOOD_SAFETY_TEMP_TONE.UNKNOWN
}

/**
 * Quiet corrective label — never styled as a second failure.
 * @param {string|null|undefined} note
 * @returns {string}
 */
export function formatFoodSafetyCorrectiveNote(note) {
  const text = String(note || '').trim()
  if (!text) return ''
  if (/^note\s*:/i.test(text)) return text
  return `Note: ${text}`
}

/**
 * Split a logged temp for coloured UI.
 * @param {{
 *   value?: number|string|null,
 *   outOfRange?: boolean|null,
 *   unit?: string,
 * }} opts
 */
export function formatFoodSafetyTempParts({
  value,
  outOfRange,
  unit = '°C',
} = {}) {
  if (value == null || value === '' || Number.isNaN(Number(value))) {
    return {
      tempLabel: null,
      statusLabel: null,
      tone: FOOD_SAFETY_TEMP_TONE.UNKNOWN,
      colour: FOOD_SAFETY_TEMP_TONE_COLOUR[FOOD_SAFETY_TEMP_TONE.UNKNOWN],
    }
  }
  const tone = foodSafetyTempToneFromOutOfRange(outOfRange)
  return {
    tempLabel: `${Number(value)}${unit}`,
    statusLabel: outOfRange === true ? 'Outside range' : null,
    tone,
    colour: FOOD_SAFETY_TEMP_TONE_COLOUR[tone],
  }
}
